// WCAG 2.5.8 / decision 11: every target has a 44px hit area, but several
// controls are drawn smaller (36 chips, 40 buttons, 24 icon buttons). React
// Native's `hitSlop` does that on native; react-native-web ignores it, so on web
// the same slop is drawn as a transparent ::after that extends the element's
// hit box without moving layout (HIT_SLOP_CSS, injected once at the app root).
// Spread `hit(n)` where `hitSlop={n}` used to be. Native ignores `dataSet`.
export const TARGET = 44;

export const slopFor = (visual: number, target = TARGET) => Math.max(0, (target - visual) / 2);

// Slop sizes the stylesheet knows; attribute selectors cannot read a number.
const STEPS = [2, 4, 6, 8, 10, 12, 14, 16, 20];

export function hitSlopCss(): string {
  const base = '[data-hit-v]::after,[data-hit-h]::after{content:"";position:absolute;top:0;right:0;bottom:0;left:0}';
  const rules = STEPS.map(
    (n) =>
      `[data-hit-v="${n}"]::after{top:-${n}px;bottom:-${n}px}[data-hit-h="${n}"]::after{left:-${n}px;right:-${n}px}`,
  );

  return [base, ...rules].join('\n');
}

type Slop = number | { vertical?: number; horizontal?: number };

export function hit(slop: Slop) {
  const vertical = typeof slop === 'number' ? slop : (slop.vertical ?? 0);
  const horizontal = typeof slop === 'number' ? slop : (slop.horizontal ?? 0);
  const dataSet: Record<string, string> = {};

  if (vertical > 0) dataSet['hit-v'] = String(vertical);
  if (horizontal > 0) dataSet['hit-h'] = String(horizontal);

  return { hitSlop: { top: vertical, bottom: vertical, left: horizontal, right: horizontal }, dataSet };
}
